export const men_articles = [
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/LIK3NVUU7ZCQBEOWIKFHLEPGA4.jpg?auth=2989bd3a614f903a329d171b8a0cc502071faa744d52e189f612cc20b72b5068",
        article_title: "Can men’s basketball make it to March Madness? What to expect from 2024-25 Ivy League play",
        article_authors: "Andrew Vincenti",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/can-mens-basketball-make-it-to-march-madness-what-to-expect-from-2024-25-ivy-league-play/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/427YL2HVLZHI3KNY2IN3HEQVBQ.jpg?auth=01bcc133f3a5a6dc80c841361b022137811118a7e59a3a04489f373d66dfdd5b",
        article_title: "Newcomers by the numbers: How first-years on men’s basketball have aided a historic start",
        article_authors: "Benjamin Rubin",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/19/newcomers-by-the-numbers-how-first-years-on-mens-basketball-have-aided-a-historic-start/"
    },
    {
        youtube_link: "https://www.youtube.com/shorts/0rtIzZSDlgY",
        article_title: "Star power and a historic start: Three things to know as men’s basketball eyes Ivy Madness",
        article_authors: "Arielle Rieder, Elliot Heath, Esmerelda Paredes, Salem Maru",
        article_link: "https://www.youtube.com/shorts/0rtIzZSDlgY"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/CZDLNE2SGJE47IYQLSDZ57ZNCM.jpg?auth=56a402c446359730ac0e9b00c00f332436bae2ec5d505dafbe7b65269cd77baf",
        article_title:"Men’s basketball falls to Yale, 92-88",
        article_authors:"Jillian Prunty",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/18/mens-basketball-falls-to-yale-92-88/"
    },
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/MYCJXHX37BE73GJQRGYNBP5JJY.jpg",
        article_title:"Spectator breaks down eight years of men’s basketball under head coach Jim Engles",
        article_authors:"Benjamin Rubin",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/21/spectator-breaks-down-eight-years-of-mens-basketball-under-head-coach-jim-engles/"
    }, 
    {
    image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/PNQ5U2VT7VFNVNCNJQSUC4QBPY.jpg",
    article_title:"Geronimo Rubio De La Rosa’s ascent to Lions stardom through the numbers",
    article_authors:"Lucas Metzger, Emilia Lebeau",
    article_link: "https://www.google.com/url?q=https://www.columbiaspectator.com/sports/2025/01/21/geronimo-rubio-de-la-rosas-ascent-to-lions-stardom-through-the-numbers/&sa=D&source=editors&ust=1737515001919825&usg=AOvVaw209n2QA27ayiJmbOApyiPL/"
    }
];